import { SubNavigationService } from './sub-navigation.service';

export { SubNavigationService };
